module.exports = __webpack_public_path__ + "static/media/checking-phone-smartphone-standing-svgrepo-com.16159369.svg";